

function displayTemoignage(i,min,max){
    if(i<=min){
        i=min;
        $("#noticePrev").attr('disabled','disabled');
    }else{
        $("#noticePrev").removeAttr('disabled');
    }

    if(i>=max){
        i=max;
        $("#noticeNext").attr('disabled','disabled');
    }else{
        $("#noticeNext").removeAttr('disabled');
    }

    var target = "#temoignage-"+i;
    var texte = (i+1)+'/'+(max + 1);


    $(".temoignage-container").hide();

    $('#noticeCurrent').html(texte).data('current',i);
    $(target).show();

}

function bindBtns(){
    //bouton prev
    $("#noticePrev").on('click',function(){
        $('html, body').animate({ scrollTop: $('#notice').offset().top-50 }, 500);
        if($(this).attr('disabled')){
            return;
        }
        var min = $("#noticeCurrent").data('min');
        var max = $("#noticeCurrent").data('max');
        var current = $("#noticeCurrent").data('current');

        var prev = current - 1;

        displayTemoignage(prev,min,max);
    });

    //bouton next
    $("#noticeNext").on('click',function(){
         $('html, body').animate({ scrollTop: $('#notice').offset().top-50 }, 500);
        if($(this).attr('disabled')){
            return;
        }
        var min = $("#noticeCurrent").data('min');
        var max = $("#noticeCurrent").data('max');
        var current = $("#noticeCurrent").data('current');

        var next = current + 1;

        displayTemoignage(next,min,max);
    });
}

$(document).ready(function(){
    bindBtns();
    $('.notice-pager-link').on('click',function(){
        var target = $(this).data('id');

        if($(this).hasClass('active')){
            return null;
        }

        //de-activate previous link
        var previousLink = $('.notice-pager-link.active');
        var previousTarget = $(previousLink).data('id');
        $('i',previousLink)
        .removeClass('fa-circle')
        .addClass('fa-circle-o');
        $(previousLink).removeClass('active');
        $("#"+previousTarget).hide();

        //activate current
        $(this).addClass('active');
        $('i',this)
        .removeClass('fa-circle-o')
        .addClass('fa-circle');
        $("#"+target).show();
    });
});
